export enum EStatusReason {
  directAward = "Direct Award",
  price = "Price",
  team = "Team",
  methodology = "Methodology",
  noSpecifiedReason = "No Specified Reason",
  notShortlisted = "Not Shortlisted",
  dq = "DQ"
}
